import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  dialogText: {
    fontFamily: 'Montserrat',
    fontWeight: '500',
    fontSize: '1rem'
  }
}
class PrivacyPolicyDialog extends React.Component {
  constructor(props){
    const { classes } = props;
    super(props);
    this.state = {
      open: false,
    };
    this.strings = props.strings;
    this.linkTextId = props.linkTextId;
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;
    return (
      <span>
        <a href="#privacypolicy" style={{cursor: "pointer"}} onClick={this.handleClickOpen}>
          {this.strings.getString(this.linkTextId)}
        </a>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="privacypolicy-dialog-title"
          aria-describedby="privacypolicy-dialog-description"
          className="validator-dialog"
          
        >
          <DialogTitle id="privacypolicy-dialog-title">{this.strings.privacyPolicy}</DialogTitle>
          <DialogContent >
            <DialogContentText id="privacypolicy-dialog-description" dangerouslySetInnerHTML={{__html: this.strings.privacyPolicyText}} className={classes.dialogText}>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              {this.strings.close}
            </Button>
          </DialogActions>
        </Dialog>
      </span>
    );
  }
}
export default withStyles(styles)(PrivacyPolicyDialog);